var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/warranties","title":"Lista gwarancji","numeral_text":['gwarancja', 'gwarancje', 'gwarancji'],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }